import * as names from '@/router/route-names'

export default [
  {
    path: '/:accountId/policy-admin',
    name: names.POLICY_ADMIN,
    component: () => import('../views/policy-admin/PolicyAdministration.vue'),
  },
  {
    path: '/:accountId/policy-admin/policy/:policyId',
    name: names.POLICY_DETAIL,
    component: () => import('../views/policy-admin/PolicyDetail.vue'),
  },
  {
    path: '/:accountId/policy-admin/external/:policyKey',
    name: names.POLICY_DETAIL_EXTERNAL,
    component: () => import('../views/policy-admin/PolicyDetail.vue'),
  },
  {
    path: '/:accountId/policy-admin/endorsements',
    name: names.ENDORSEMENTS,
    component: () => import('../views/policy-admin/Endorsements.vue'),
  },
  {
    path: '/:accountId/policy-admin/premium-summary',
    name: names.PREMIUM_SUMMARY,
    component: () => import('../views/policy-admin/PremiumSummary.vue'),
  },
  {
    path: '/:accountId/policy-admin/proposals',
    name: names.PROPOSALS,
    component: () => import('../views/policy-admin/Proposals.vue'),
  },
  {
    path: '/:accountId/policy-admin/allocations',
    name: names.ALLOCATIONS,
    component: () => import('../views/policy-admin/Allocations.vue'),
  },
  {
    path: '/:accountId/policy-admin/insurance-to-loan',
    name: names.INSURANCE_VS_MARKET,
    component: () => import('../views/policy-admin/InsuranceToLoanBids.vue'),
  },
  {
    path: '/:accountId/policy-admin/insurance-to-loan/:bidId',
    name: names.INSURANCE_TO_LOAN_BID,
    component: () => import('../views/policy-admin/InsuranceVsMarket.vue'),
  },
]
